import { BookingTolerancesAggregatorProviderMap } from '../../../integrated-client';
import {
  ApplicationType,
  BrandAndMarketListItem,
  GuidIdAndLabel,
  GuidIdCodeAndLabel,
  Int32IdAndLabel,
} from '../../../integrated-client/models'

export interface IBookingTolerancesEditorData {
  id?: string;
  description?: string | null;
  relevance?: number;
  comment?: string | null;
  disabled?: boolean;
  brandAndMarket?: BrandAndMarketListItem;
  brands?: Array<number> | null;
  markets?: Array<string> | null;
  distributionChannels?: Array<Int32IdAndLabel> | null;
  suppliers?: Array<GuidIdAndLabel> | null;
  carriers?: Array<GuidIdCodeAndLabel> | null;
  applicationType?: ApplicationType;
  currency?: string | null;
  toleranceAmountUp?: number | null;
  toleranceAmountDown?: number | null;
  excludeCarriers?: boolean;
  aggregatorProviderMaps?: Array<BookingTolerancesAggregatorProviderMap> | null;
}

export interface IEditorData {
  bookingTolerancesEditorData: IBookingTolerancesEditorData;
  validation?: any;
}

export class BookingTolerancesEditorData implements IBookingTolerancesEditorData {
  id?: string;
  description?: string | null;
  relevance?: number;
  comment?: string | null;
  disabled?: boolean;
  brandAndMarket?: BrandAndMarketListItem;
  brands?: Array<number> | null;
  markets?: Array<string> | null;
  distributionChannels?: Array<Int32IdAndLabel> | null;
  suppliers?: Array<GuidIdAndLabel> | null;
  carriers?: Array<GuidIdCodeAndLabel> | null;
  applicationType?: ApplicationType;
  currency?: string | null;
  toleranceAmountUp?: number | null;
  toleranceAmountDown?: number | null;
  excludeCarriers?: boolean;
  aggregatorProviderMaps?: Array<BookingTolerancesAggregatorProviderMap> | null;
}

export class EditorData implements IEditorData {

  bookingTolerancesEditorData: IBookingTolerancesEditorData;
  validation?: any;

  constructor() {
    this.bookingTolerancesEditorData = new BookingTolerancesEditorData();
  }
}
